export default {"src":"/_next/static/media/searchHeaderIcon.34b43a65.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};